import { useEffect, useState } from "react";
import axios from "axios";
import { Table } from "antd";
import dayjs from "dayjs";

function AttendanceImport() {
    const [data, setData] = useState([]);

    useEffect(() => {
        getlist();
    }, []);

    const getlist = async () => {
        const url = "http://localhost:3001/fetch-attendance?start_date=2025-03-06T00:00:00.000Z&end_date=2025-03-06T23:59:59.999Z";
        try {
            const res = await axios.get(url);
            console.log(res); // Log the entire response to verify the data structure
            if (res.status === 200) {
                setData(res.data.data); // Update state with the data received
            } else {
                console.error("No data found or failed to fetch.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // Ant Design Table columns
    const columns = [
        {
            title: "User SN",
            dataIndex: "userSn",
            key: "userSn",
            render: (text) => text || "N/A",
        },
        {
            title: "Device User ID",
            dataIndex: "deviceUserId",
            key: "deviceUserId",
            render: (text) => text || "N/A",
        },
        {
            title: "Record Time",
            dataIndex: "recordTime",
            key: "recordTime",
            render: (text) => text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "N/A",
        },
        {
            title: "IP Address",
            dataIndex: "ip",
            key: "ip",
            render: (text) => text || "N/A",
        },
    ];

    return (
        <div>
           <br/>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={(record) => record.userSn} // Ensure unique row keys
                bordered
                pagination={{ pageSize: 10 }} // Optional pagination
            />
        </div>
    );
}

export default AttendanceImport;
